/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateTopUpRequest = {
    /**
     * Payment provider. `crypto` is accepted as an alias for `nowpayments`.
     */
    provider: CreateTopUpRequest.provider;
    amount_credits: CreateTopUpRequest.amount_credits;
};
export namespace CreateTopUpRequest {
    /**
     * Payment provider. `crypto` is accepted as an alias for `nowpayments`.
     */
    export enum provider {
        CRYPTO = 'crypto',
        NOWPAYMENTS = 'nowpayments',
        PLATEGA = 'platega',
    }
    export enum amount_credits {
        '_100' = 100,
        '_200' = 200,
        '_300' = 300,
        '_500' = 500,
        '_1000' = 1000,
        '_2500' = 2500,
        '_5000' = 5000,
        '_10000' = 10000,
        '_20000' = 20000,
    }
}

